export const landingGeneralSettingTranslation = {
  en: {
    Home: "Home",
    Landing: "Landing",
    "Landing General Settings": "Landing General Settings",
    "App Name (EN)": "App Name (EN)",
    "App Name (AR)": "App Name (AR)",
    "App Bio (EN)": "App Bio (EN)",
    "App Bio (AR)": "App Bio (AR)",
    "Logo Color": "Logo Color",
    "Logo White": "Logo White",
    "Logo Black": "Logo Black",
    Email: "Email",
    "Support Email": "Support Email",
    "Sales Email": "Sales Email",
    "Address(EN)": "Address(EN)",
    "Address(AR)": "Address(AR)",
    "Phone No 1": "Phone No 1",
    "Phone No 2": "Phone No 2",
    "Webtrustseal Link": "Webtrustseal Link",
    "DGA Link": "DGA Link",
    "Android Link": "Android Link",
    "iOS Link": "iOS Link",
    "Google Map URL": "Google Map URL",
    "Google Map Iframe": "Google Map Iframe",
    "Our Vision (EN)": "Our Vision (EN)",
    "Our Vision (AR)": "Our Vision (AR)",
    "Our Mission (EN)": "Our Mission (EN)",
    "Our Mission (AR)": "Our Mission (AR)",
    "Landing Primary Color": "Landing Primary Color",
    "Footer Link Text Color": "Footer Link Text Color",
    "Landing Header Color": "Landing Header Color",
    "Upload Sitemap XML": "Upload Sitemap XML",
    "Header Settings": "Header Settings",
    "Footer Settings": "Footer Settings",
    "Upload Sitemap": "Upload Sitemap",

    "Is Partners Header Enabled": "Is Partners Header Enabled",
    "Is Customers Header Enabled": "Is Customers Header Enabled",
    "Is Blogs Header Enabled": "Is Blogs Header Enabled",
    "Is News Header Enabled": "Is News Header Enabled",
    "Is Help Center Header Enabled": "Is Help Center Header Enabled",
    "Is Team Members Header Enabled": "Is Team Members Header Enabled",
    "Is General Manager Speech Header Enabled":
      "Is General Manager Speech Header Enabled",
    "Is Why HaatSign Header Enabled": "Is Why HaatSign Header Enabled",
    "Is About Us Header Enabled": "Is About Us Header Enabled",
    "Is Newsletter Subscription Footer Enabled":
      "Is Newsletter Subscription Footer Enabled",
    "Is Latest News Footer Enabled": "Is Latest News Footer Enabled",
    "Is Blogs Footer Enabled": "Is Blogs Footer Enabled",
    "Is Company Files Footer Enabled": "Is Company Files Footer Enabled",
    "Is Tutorials Footer Enabled": "Is Tutorials Footer Enabled",
    "Is Careers Footer Enabled": "Is Careers Footer Enabled",
    "Is Faqs Footer Enabled": "Is Faqs Footer Enabled",
    "Is Contact Us Footer Enabled": "Is Contact Us Footer Enabled",
    "Is Sitemap Footer Enabled": "Is Sitemap Footer Enabled",
    "Is About Haatsign Footer Enabled": "Is About Haatsign Footer Enabled",
    "Is Partners Footer Enabled": "Is Partners Footer Enabled",
    "Is Customers Footer Enabled": "Is Customers Footer Enabled",
    "Is Membership Footer Enabled": "Is Membership Footer Enabled",
    "Is Certificates Footer Enabled": "Is Certificates Footer Enabled",
    "Is Why HaatSign Footer Enabled": "Is Why HaatSign Footer Enabled",
    "Is Regulations Footer Enabled": "Is Regulations Footer Enabled",
    "Is Issuing Digital Certificate Footer Enabled":
      "Is Issuing Digital Certificate Footer Enabled",
    "Is E-Signature Footer Enabled": "Is E-Signature Footer Enabled",
    "Is Electronic and Time Stamp Footer Enabled":
      "Is Electronic and Time Stamp Footer Enabled",
    "Is Automate Workflow Signing Service Footer Enabled":
      "Is Automate Workflow Signing Service Footer Enabled",
    "Is DGA Footer Enabled": "Is DGA Footer Enabled",
    "Is Webtrust Footer Enabled": "Is Webtrust Footer Enabled",
    "Is ISO Footer Enabled": "Is ISO Footer Enabled",
    "Is Android Footer Enabled": "Is Android Footer Enabled",
    "Is IOS Footer Enabled": "Is IOS Footer Enabled",
    "Is Social Media Footer Enabled": "Is Social Media Footer Enabled",
    "Is Language Switcher Footer Enabled":
      "Is Language Switcher Footer Enabled",
    "Is Privacy Policy Footer Enabled": "Is Privacy Policy Footer Enabled",
    "Is Terms of Use Footer Enabled": "Is Terms of Use Footer Enabled",
    "Is Return & Refund Policy Footer Enabled":
      "Is Return & Refund Policy Footer Enabled",
    "Is Quality Policy Footer Enabled": "Is Quality Policy Footer Enabled",
    "Is Security Policy Footer Enabled": "Is Security Policy Footer Enabled",
    "Is Copyright Text Footer Enabled": "Is Copyright Text Footer Enabled",
    Update: "Update",
    "Preview Sitemap": "Preview Sitemap",
    "Landing Controls": "Landing Controls",
    "Is Under Maintenance": "Is Under Maintenance",
    "Is Coming Soon": "Is Coming Soon",
    "Coming Soon Until": "Coming Soon Until",
    "Second Footer Settings": "Second Footer Settings",
    "Drag & drop or click to upload sitemap.xml":"Drag & drop or click to upload sitemap.xml",
    "Is Pricing Header Enabled": "Is Pricing Header Enabled",
    "Is Pricing Footer Enabled":"Is Pricing Footer Enabled",
    "Is Dark Theme Icons": "Is Dark Theme Icons",
    "Maintenance Logo (EN)": "Maintenance Logo (EN)",
    "Maintenance Logo (AR)": "Maintenance Logo (AR)",
    "Default SEO keywords": "Default SEO keywords",
    "Preview": "Preview",
    "View Logo Color": "View Logo Color",
    "View Logo White": "View Logo White",
    "View Logo Black": "View Logo Black",
    "View Maintenance Logo (EN)": "View Maintenance Logo (EN)",
    "View Maintenance Logo (AR)": "View Maintenance Logo (AR)",
    "Privacy Policy Link": "Privacy Policy Link",
    "Terms of Service Link": "Terms of Service Link",

  },
  ar: {
    Home: "الرئيسية",
    Landing: "الصفحة الرئيسية",
    "Landing General Settings": "إعدادات الصفحة العامة",
    "App Name (EN)": "اسم التطبيق (EN)",
    "App Name (AR)": "اسم التطبيق (AR)",
    "App Bio (EN)": "نبذة عن التطبيق (EN)",
    "App Bio (AR)": "نبذة عن التطبيق (AR)",
    "Logo Color": "الشعار ملون",
    "Logo White": "الشعار الأبيض",
    "Logo Black": "الشعار الأسود",
    Email: "البريد الإلكتروني",
    "Support Email": "البريد الإلكتروني للدعم",
    "Sales Email": "البريد الإلكتروني للمبيعات",
    "Address(EN)": "العنوان (EN)",
    "Address(AR)": "العنوان (AR)",
    "Phone No 1": "رقم الهاتف 1",
    "Phone No 2": "رقم الهاتف 2",
    "Webtrustseal Link": "رابط Webtrustseal",
    "DGA Link": "رابط DGA",
    "Android Link": "رابط أندرويد",
    "iOS Link": "رابط iOS",
    "Google Map URL": "رابط خريطة جوجل",
    "Google Map Iframe": "إطار خريطة جوجل",
    "Our Vision (EN)": "رؤيتنا (EN)",
    "Our Vision (AR)": "رؤيتنا (AR)",
    "Our Mission (EN)": "مهمتنا (EN)",
    "Our Mission (AR)": "مهمتنا (AR)",
    "Landing Primary Color": "اللون الأساسي للصفحة الرئيسية",
    "Footer Link Text Color": "لون نص رابط التذييل",
    "Landing Header Color": "لون ترويسة الصفحة الرئيسية",
    "Upload Sitemap XML": "رفع خريطة الموقع XML",
    "Header Settings": "إعدادات الترويسة",
    "Footer Settings": "إعدادات التذييل",
    "Upload Sitemap":"تحميل خريطة الموقع",
    "Is Partners Header Enabled": "هل تم تمكين الترويسة الشركاء",
    "Is Customers Header Enabled": "هل تم تمكين الترويسة العملاء",
    "Is Blogs Header Enabled": "هل تم تمكين الترويسة المدونات",
    "Is News Header Enabled": "هل تم تمكين الترويسة الأخبار",
    "Is Help Center Header Enabled": "هل تم تمكين الترويسة مركز المساعدة",
    "Is Team Members Header Enabled": "هل تم تمكين الترويسة أعضاء الفريق",
    "Is General Manager Speech Header Enabled":
      "هل تم تمكين الترويسة خطاب المدير العام",
    "Is Why HaatSign Header Enabled": "هل تم تمكين الترويسة لماذا HaatSign",
    "Is About Us Header Enabled": "هل تم تمكين الترويسة من نحن",
    "Is Newsletter Subscription Footer Enabled":
      "هل تم تمكين تذييل اشتراك النشرة الإخبارية",
    "Is Latest News Footer Enabled": "هل تم تمكين تذييل الأخبار الأخيرة",
    "Is Blogs Footer Enabled": "هل تم تمكين تذييل المدونات",
    "Is Company Files Footer Enabled": "هل تم تمكين تذييل ملفات الشركة",
    "Is Tutorials Footer Enabled": "هل تم تمكين تذييل الدروس",
    "Is Careers Footer Enabled": "هل تم تمكين تذييل الوظائف",
    "Is Faqs Footer Enabled": "هل تم تمكين تذييل الأسئلة الشائعة",
    "Is Contact Us Footer Enabled": "هل تم تمكين تذييل اتصل بنا",
    "Is Sitemap Footer Enabled": "هل تم تمكين تذييل خريطة الموقع",
    "Is About Haatsign Footer Enabled": "هل تم تمكين تذييل حول هات ساين",
    "Is Partners Footer Enabled": "هل تم تمكين تذييل الشركاء",
    "Is Customers Footer Enabled": "هل تم تمكين تذييل العملاء",
    "Is Membership Footer Enabled": "هل تم تمكين تذييل العضوية",
    "Is Certificates Footer Enabled": "هل تم تمكين تذييل الشهادات",
    "Is Why HaatSign Footer Enabled": "هل تم تمكين تذييل لماذا هاتساين",
    "Is Regulations Footer Enabled": "هل تم تمكين تذييل اللوائح",
    "Is Issuing Digital Certificate Footer Enabled":
      "هل تم تمكين تذييل إصدار الشهادة الرقمية",
    "Is E-Signature Footer Enabled": "هل تم تمكين تذييل التوقيع الإلكتروني",
    "Is Electronic and Time Stamp Footer Enabled":
      "هل تم تمكين تذييل الطابع الزمني الإلكتروني",
    "Is Automate Workflow Signing Service Footer Enabled":
      "هل تم تمكين تذييل خدمة توقيع سير العمل التلقائي",
    "Is DGA Footer Enabled": "هل تم تمكين تذييل DGA",
    "Is Webtrust Footer Enabled": "هل تم تمكين تذييل Webtrust",
    "Is ISO Footer Enabled": "هل تم تمكين تذييل ISO",
    "Is Android Footer Enabled": "هل تذييل أندرويد مفعّل",
    "Is IOS Footer Enabled": "هل تم تمكين تذييل IOS",
    "Is Social Media Footer Enabled":
      "هل تم تمكين تذييل وسائل التواصل الاجتماعي",
    "Is Language Switcher Footer Enabled": "هل تم تمكين تذييل محول اللغة",
    "Is Privacy Policy Footer Enabled": "هل تم تمكين تذييل سياسة الخصوصية",
    "Is Terms of Use Footer Enabled": "هل تم تمكين تذييل شروط الاستخدام",
    "Is Return & Refund Policy Footer Enabled":
      "هل تم تمكين تذييل سياسة الاسترجاع والاسترداد",
    "Is Quality Policy Footer Enabled": "هل تم تمكين تذييل سياسة الجودة",
    "Is Security Policy Footer Enabled": "هل تم تمكين تذييل سياسة الأمان",
    "Is Copyright Text Footer Enabled": "هل تم تمكين تذييل نص حقوق النشر",
    Update: "تحديث",
    "Preview Sitemap": "معاينة خريطة الموقع ",
    "Landing Controls": "عناصر التحكم في الصفحة الرئيسية",
    "Is Under Maintanence": "تحت الصيانة",
    "Is Coming Soon": "قريباً",
    "Coming Soon Until": "قريباً حتى",
    "Select date and time": "اختر التاريخ والوقت",
    "Second Footer Settings": "إعدادات التذييل الثاني",
    "Drag & drop or click to upload sitemap.xml":"اسحب وأفلت أو انقر لتحميل ملف sitemap.xml",
    "Is Pricing Header Enabled": "هل تم تمكين ترويسة التسعير",
    "Is Pricing Footer Enabled":"هل تم تمكين تذييل التسعير",
    "Is Dark Theme Icons": "هل تم تمكين أيقونات السمة الداكنة",
    "Maintenance Logo (EN)": "شعار الصيانة (EN)",
    "Maintenance Logo (AR)": "شعار الصيانة (AR)",
    "Default SEO keywords": "الكلمات الرئيسية الافتراضية لتحسين محركات البحث",
    "Preview": "معاينة",
    "View Logo Color": "عرض الشعار الملون",
    "View Logo White": "عرض الشعار الأبيض",
    "View Logo Black": "عرض الشعار الأسود",
    "View Maintenance Logo (EN)": "عرض شعار الصيانة (EN)",
    "View Maintenance Logo (AR)": "عرض شعار الصيانة (AR)",
    "Privacy Policy Link": "رابط سياسة الخصوصية",
    "Terms of Service Link": "رابط شروط الخدمة",
  },
};
